module.exports = {
  title: `yerang.kim`,
  description: `devlog run by yerang kim`,
  author: `Yerang Kim`,
  introduction: `Python, iOS 개발자. 🇰🇷한국어 🇬🇧English 🇯🇵日本語`,
  siteUrl: `https://yerang.kim`, // Your blog site url
  social: {
    twitter: ``, // Your Twitter account
    github: `withyeah`, // Your GitHub account
    medium: ``, // Your Medium account
    facebook: ``, // Your Facebook account
    linkedin: `yerang-kim`, // Your LinkedIn account
  },
  icon: `content/assets/felog.png`, // Add your favicon
  keywords: [`blog`],
  comment: {
    disqusShortName: 'yerang-kim', // Your disqus-short-name. check disqus.com.
    utterances: 'withyeah/devlog', // Your repository for archive comment
  },
  configs: {
    countOfInitialPost: 10, // Config your initial count of post
  },
  sponsor: {
    buyMeACoffeeId: '',
  },
  share: {
    facebookAppId: '', // Add facebookAppId for using facebook share feature v3.2
  },
  ga: '', // Add your google analytics tranking ID
}
